import React from "react";
import { Truck, Package, Clock, ChartBar } from "@phosphor-icons/react";

const iconMap = {
  truck: Truck,
  package: Package,
  clock: Clock,
  chart: ChartBar,
};

const accentMap = {
  yellow: {
    border: "border-yellow-500/30",
    text: "text-yellow-400",
    bar: "bg-yellow-500",
  },
  blue: {
    border: "border-zinc-800",
    text: "text-zinc-100",
    bar: "bg-blue-500",
  },
  emerald: {
    border: "border-zinc-800",
    text: "text-zinc-100",
    bar: "bg-emerald-500",
  },
  orange: {
    border: "border-zinc-800",
    text: "text-zinc-100",
    bar: "bg-orange-500",
  },
};

export default function StatCard({ label, value, unit, iconName = "truck", accent = "yellow", testId }) {
  const Icon = iconMap[iconName] || Truck;
  const style = accentMap[accent] || accentMap.yellow;

  return (
    <div
      data-testid={testId}
      className={`relative bg-zinc-900/60 border ${style.border} p-4 sm:p-6 hover:-translate-y-[2px] transition-transform duration-200 group`}
    >
      <div className={`absolute left-0 top-0 h-full w-[3px] ${style.bar}`} />
      <div className="flex items-start justify-between mb-4 sm:mb-6">
        <span className="overline text-zinc-500 text-[0.6rem] sm:text-xs">{label}</span>
        <Icon size={18} weight="duotone" className="text-zinc-600 group-hover:text-zinc-300 transition-colors" />
      </div>
      <div className="flex items-baseline gap-2 flex-wrap">
        <span className={`font-display font-black text-2xl sm:text-3xl lg:text-4xl leading-none ${style.text} break-all`}>{value}</span>
        {unit && <span className="overline text-zinc-500 text-[0.6rem]">{unit}</span>}
      </div>
    </div>
  );
}
